import zhtwLang from 'element-ui/lib/locale/lang/zh-TW'
const messages = {
  ...zhtwLang,
  "banner1": "世界將因我們而變得更美好",
  "banner2": "",
  "banner3": "Solar for Everybody",
  "english": "英文",
  "polish": "波蘭語",
  "spanish": "西班牙語",
  "turkish": "土耳其語",
  "germany": "德語",
  "french": "法語",
  "italian": "義大利語",
  "systemData1": "安裝資訊",
  "installationLocation1": "安裝位置",
  "customerData1": "客戶資訊",
  "claimData": "客訴信息",
  "shippingAddress1": "收貨地址",
  "customerData": "客戶資訊",
  "customerType": "客戶類型",
  "selectCustomer": "請選擇客戶類型",
  "--None--": "--無--",
  "Installer": "安裝商",
  "End-customer": "終端客戶",
  "Distributor": "分銷商",
  "EPC": "EPC",
  "Other": "其他",
  "companyName": "公司名稱",
  "typeCompanyName": "請輸入公司名稱",
  "contacts": "連絡人",
  "typeContacts": "請輸入連絡人",
  "contactInformation": "聯繫電話",
  "typeContactInformation": "請輸入聯繫電話",
  "shippingAddress": "收貨地址（默認為配件或替換機收貨地址）",
  "country": "國家/地區",
  "typeCountry": "請輸入國家/地區",
  "province": "省份",
  "typeProvince": "請輸入省份",
  "city": "城市",
  "typeCity": "請輸入城市",
  "area": "詳細地址",
  "typeArea": "請輸入詳細地址（精確到門牌號）",
  "contacts01": "移動電話",
  "typeContacts01": "請輸入移動電話",
  "postCode": "郵編",
  "typePostCode": "請輸入郵編",
  "email": "郵箱",
  "typeEmail": "請輸入郵箱",
  "errorEmail": "請輸入有效的郵箱地址。",
  "installationLocation": "安裝位置（使用收貨位址",
  "purchaseDate": "購買日期",
  "typePurchaseDate": "請輸入購買日期",
  "installDate": "安裝日期",
  "typeInstallDate": "請輸入安裝日期",
  "faultyDeviceType": "故障設備類型",
  "selectFaultyDeviceType": "請選擇故障設備類型",
  "faultDate": "故障日期",
  "typeFaultDate": "請輸入故障日期",
  "deviceSerialNumber": "設備序號",
  "typeDeviceSerialNumber": "請輸入裝置序號",
  "faultySymptom": "故障原因",
  "selectFaultySymptom": "請選擇故障原因",
  "errorDescription": "詳細的問題描述",
  "typeErrorDescription": "請輸入詳細的問題描述",
  "purchaseFileId": "購買憑證（附件）",
  "purchaseDesc": "購買憑證必須包含客戶名稱，安裝地點，設備型號和實際金額",
  "breakFileId": "故障憑證（附件）",
  "breakDesc": "請提供故障資訊和設備序號的圖片",
  "upload": "上傳",
  "systemData": "安裝資訊 (可選)",
  "systemData01": "同一安裝位置是否首次故障?",
  "Yes": "是",
  "No": "否",
  "Unknown": "不清楚",
  "systemData02": "同一電站其他逆變器是否有相同故障?",
  "systemData03": "早期客訴原因",
  "enterSystemData03": "請輸入早期客訴原因",
  "systemData04": "同一電站其它故障設備故障詳細描述",
  "enterSystemData04": "請輸入同一電站其它故障設備故障詳細描述",
  "systemData05": "設備安裝環境",
  "systemData0501": "室內",
  "systemData0502": "室外（有建築遮擋或遮陽棚）",
  "systemData0503": "室外（陽光直射逆變器）)",
  "systemData0504": "水面",
  "systemData0505": "其他",
  "systemData06": "太陽能電池板安裝環境",
  "systemData0601": "地面",
  "systemData0602": "屋頂",
  "systemData0603": "水面",
  "systemData0604": "其他",
  "systemData07": "太陽能電池型號與廠家名稱",
  "typeSystemData07": "請輸入太陽能電池型號與廠家名稱",
  "systemData08": "直流接入模式",
  "systemData0801": "獨立模式",
  "systemData0802": "其他",
  "pleaseSelect": "請選擇",
  "add": "添加",
  "delete": "刪除",
  "pv10": "組串組件(塊)",
  "pv101": "PV1string solar panel(pieces)",
  "pv102": "PV2string solar panel(pieces)",
  "pv103": "PV3string solar panel(pieces)",
  "pv104": "PV4string solar panel(pieces)",
  "circuit01": "開路電壓(V)",
  "alternatingVoltage": "交流電壓",
  "l1l2": "交流電壓L1 - L2(V)",
  "l1n": "交流電壓L1 - N(V)",
  "l2l3": "交流電壓L2 - L3(V)",
  "l2n": "交流電壓L2 - N(V)",
  "l1l3": "交流電壓L1 - L3(V)",
  "l3n": "交流電壓L3 - N(V)",
  "l1pe": "交流電壓L1 - PE(V)",
  "l3pe": "交流電壓L3 - PE(V)",
  "l2pe": "交流電壓L2 - PE(V)",
  "npe": "交流電壓N - PE(V)",
  "complaintFileId": "上傳附件",
  "activeTip": "提示：您的更多安裝資訊將會説明我們快速確定故障問題。",
  "submitBtn": "確定",
  "pleaseType": "請輸入",
  "submitSuccess": "操作成功",
  "submitDesc": "存在一些必填項未填寫，請確認後重新提交。謝謝！",
  "typeUpload": "請上傳",
  "resetUpload": "重新上傳",
  "selectErrorMessage": "請選擇故障資訊",
  "errorMessage": "其他",
  "MPPT": "MPPT",
  "chinese": "中文",
  "dutch": "荷蘭語",
  "hungary": "匈牙利語",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "同意並願意遵守愛士惟新能源技術隱私條款",
  "iagree": "同意並願意遵守愛士惟新能源技術隱私條款",
  "language": "語言",
  "ptbr": "葡萄牙語 (巴西)",
  "zhtw": "繁體中文",
  "documentTitle": "質保 │愛士惟",
  "validateNumber": "請輸入一個整數"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/zh-TW.js